import styles from "./servico-card.module.css";
import logoCard from "../../../images/_finais/logo_servico_card_compress.webp";
import { NavLink } from "react-router-dom";

interface IProps {
  title: string;
  description: string;
  onHandlePages: any;
  url: string;
}

const ServicoCard = ({ title, description, onHandlePages, url }: IProps) => {
  return (
    <li className={styles.card_servico}>
      <img
        className={styles.logo_card}
        src={logoCard}
        alt="Logo TruEvidence."
        loading="lazy"
      />
      <h3 className={styles.servico_title}>{title}</h3>
      <p className={styles.servico_shortDescr}>{description}</p>
      <NavLink to={url} onClick={() => onHandlePages("PRODUTOS")}>
        <button className={styles.btn_ver}>VER</button>
      </NavLink>
    </li>
  );
};

export default ServicoCard;
